import React, { PropsWithChildren } from 'react';
import '../styles/styles.scss';
import './WidgetTile.scss';

export type WidgetTileProps = PropsWithChildren<{
    className: string;
}>;

export function WidgetTile(props: WidgetTileProps) {
    const { className, children } = props;

    return <div className={`WidgetTile capsule ${className}`}>{children}</div>;
}
